import React from 'react';
import {useTranslation} from 'react-i18next';
import {goTo} from '@utils';

const RightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-3 h-3"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none">
      <path
        d="M5 9.22222L8.11111 6.11111L5 3"
        stroke="#8D97AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

function ResultTitle(props: any) {
  const {title, icon, type, id} = props;
  const {i18n} = useTranslation();
  return (
    <div className="flex items-center p-3 bg-gradient-to-b from-white to-white/0 gap-2">
      <img className="w-9 h-9" src={icon}></img>
      <div className="text-t1 font-bold text-sm">{title}</div>
      <div
        className="rounded border ml-auto border-[#D8E0EA] py-1 px-2 flex gap-1 items-center"
        onClick={() =>
          goTo('ResultDetailV2', {
            id,
            type,
            title,
            icon,
          })
        }>
        <span className="text-t2 text-sm font-medium">
          {i18n.t('home.label.more')}
        </span>
        <RightIcon />
      </div>
    </div>
  );
}

export default ResultTitle;
